import {
  useEffect, useRef, useState,
} from 'react';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/klaviyoForm.module.scss';

import type { IKlaviyoFormAtom } from './types';


const getIframeScrollHeight = (iframe: HTMLIFrameElement) => (iframe.contentWindow?.document?.documentElement?.querySelector('.klaviyo-form')?.scrollHeight || 0);

const IframeKlaviyoForm = ({
  className,
  formId,
  ...rest
}: IKlaviyoFormAtom) => {
  const ref = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState<string | number>('auto');
  const [hydrated, setHydrated] = useState<boolean>(false);
  const [intervalId, setIntervalId] = useState<number>(0);
  const [src, setSrc] = useState<string>('/klaviyo-integration.html');

  useEffect(() => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams.toString();

    setSrc(`/klaviyo-integration.html?formId=${formId}&${searchParams}`);

    setIntervalId(window.setInterval(() => {
      if (ref?.current) {
        const iframeHeight = getIframeScrollHeight(ref.current);
        if (height !== iframeHeight) {
          setHeight(iframeHeight);
        }
      }
    }, 1000));

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return null;
  }

  return (
    <iframe
      allowTransparency
      className={generateClassName([className, styles.klaviyoFormIframe])}
      frameBorder="0"
      height={height}
      ref={ref}
      scrolling="no"
      src={src}
      title="klaviyo form"
      {...rest}
    />
  );
};

const StaticKlaviyoForm = ({
  className,
  formId,
  ...rest
}: IKlaviyoFormAtom) => (
  <div className={generateClassName([className, 'form', `klaviyo-form-${formId}`])} {...rest} />
);

const KlaviyoFormAtom = ({
  className,
  formId,
  ...rest
}: IKlaviyoFormAtom) => {
  if (process.env.GENERATOR === 'astro') {
    return <StaticKlaviyoForm className={className} formId={formId} {...rest} />;
  }

  return <IframeKlaviyoForm className={className} formId={formId} {...rest} />;
};

export default KlaviyoFormAtom;
